import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { FAQ_ITEMS } from '@/libs/faqData';
import { useStyles } from './styles';
const animateProps = {
    attributeName: 'points',
    dur: '140ms',
    fill: 'freeze',
    keyTimes: '0; 0.5; 1',
    calcMode: 'spline',
    begin: 'indefinite',
};
const opened = '15 7.72 8.5 1.13 2 7.72';
const closed = '15 1.13 8.5 7.72 2 1.13';
const middle = '15.85 4.42 8.5 4.42 1.15 4.42';
const AccordionIcon = memo(({ isOpened }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const expandRef = useRef(null);
    const collapseRef = useRef(null);
    useEffect(() => {
        const timer = setTimeout(() => setIsInitialized(true), 200);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (isOpened) {
            expandRef.current?.beginElement();
        }
        else {
            collapseRef.current?.beginElement();
        }
    }, [isOpened]);
    const polygonProps = {
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2.4,
        fill: 'none',
        fillRule: 'evenodd',
        points: isOpened ? opened : closed,
    };
    return (_jsxs("svg", { viewBox: "0 0 17 8.85", width: 16, height: 16, children: [_jsx("polyline", { ...polygonProps, opacity: isInitialized ? 0 : 1 }), _jsxs("polyline", { ...polygonProps, opacity: isInitialized ? 1 : 0, children: [_jsx("animate", { ...animateProps, ref: expandRef, values: `${closed}; ${middle}; ${opened}`, keySplines: "0.12, 0, 0.38, 0; 0.2, 1, 0.68, 1" }), _jsx("animate", { ...animateProps, ref: collapseRef, values: `${opened}; ${middle}; ${closed}`, keySplines: "0.2, 0, 0.68, 0; 0.2, 1, 0.68, 1" })] })] }));
});
const Item = ({ question, answer, }) => {
    const classes = useStyles();
    const [isOpened, setIsOpened] = useState(false);
    return (_jsxs("li", { className: classes.faqItem, children: [_jsxs("button", { onClick: () => setIsOpened(!isOpened), className: classes.faqButton, children: [question, _jsx(AccordionIcon, { isOpened: isOpened })] }), _jsx(motion.div, { variants: {
                    closed: { height: 0, marginTop: 0, opacity: 0.6 },
                    open: { height: 'auto', marginTop: 8, opacity: 1 },
                }, initial: "closed", animate: isOpened ? 'open' : 'closed', transition: { duration: 0.15, ease: 'easeInOut' }, style: { overflow: 'hidden' }, children: _jsx("p", { className: classes.faqAnswer, children: answer }) })] }));
};
export const FaqSection = () => {
    const classes = useStyles();
    return (_jsx(_Fragment, { children: _jsx("section", { className: classes.section, "data-no-padding": true, children: _jsx(Faq, {}) }) }));
};
export const Faq = () => {
    const classes = useStyles();
    return (_jsxs("div", { className: classes.faqContainer, children: [_jsx("h2", { className: classes.faqTitle, children: "\u041E\u0442\u0432\u0435\u0442\u044B \u043D\u0430 \u0432\u043E\u043F\u0440\u043E\u0441\u044B" }), _jsx("ul", { children: FAQ_ITEMS.map(({ question, answer }, index) => (_jsx(Item, { question: question, answer: answer }, question))) })] }));
};
